import { Injectable } from '@angular/core';
import { Individual, Company } from '../interfaces/new-customer-dialog.interface';

@Injectable({
  providedIn: 'root'
})
export class CustomerValidationService {

  /**
   * Validates an individual customer
   */
  isValidIndividual(individual: Individual, isNewIndividual: boolean = false, birthDateString?: string): boolean {
    // Név kötelező
    if (individual.fullName.trim() === '') {
      return false;
    }

    // Születési dátum kötelező és formátum ellenőrzése
    let birthDateStringToCheck = '';
    
    if (isNewIndividual && birthDateString) {
      // Új individual hozzáadásakor a birthDateString paraméter alapján
      birthDateStringToCheck = birthDateString;
    } else {
      // Fő individual esetén a birthDate-ből alakítjuk vissza
      birthDateStringToCheck = this.formatDateToString(individual.birthDate);
    }
    
    // Születési dátum kötelező
    if (!birthDateStringToCheck || birthDateStringToCheck.trim() === '') {
      return false;
    }
    
    // Születési dátum formátum ellenőrzése
    if (!this.isValidBirthDateFormat(birthDateStringToCheck)) {
      return false;
    }

    return true;
  }

  /**
   * Validates a company
   */
  isValidCompany(company: Company): boolean {
    return company.name.trim() !== '';
  }

  /**
   * Születési dátum formátum validáció (yyyy.mm.dd)
   */
  isValidBirthDateFormat(dateString: string): boolean {
    if (!dateString || dateString.trim() === '') {
      return false; // Üres dátum nem megengedett - kötelező mező
    }

    // yyyy.mm.dd formátum ellenőrzése
    const dateRegex = /^(\d{4})\.(\d{2})\.(\d{2})$/;
    const match = dateString.match(dateRegex);
    
    if (!match) {
      return false; // Nem megfelelő formátum
    }
    
    const year = parseInt(match[1], 10);
    const month = parseInt(match[2], 10) - 1; // JavaScript Date hónapok 0-indexeltek
    const day = parseInt(match[3], 10);
    
    // Ellenőrizzük, hogy létező dátum-e
    const date = new Date(year, month, day);
    
    if (date.getFullYear() !== year || 
        date.getMonth() !== month || 
        date.getDate() !== day) {
      return false; // Nem létező dátum (pl. 2023.02.30)
    }
    
    // Ésszerű évszám ellenőrzés (1900-2030)
    if (year < 1900 || year > 2030) {
      return false;
    }
    
    return true;
  }

  /**
   * Date formázás segéd metódus
   */
  private formatDateToString(date: Date | null): string {
    if (!date) return '';
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}.${month}.${day}`;
  }
}